// Path: sec-parser/client/src/pages/LoginPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Card, Input, Button, Typography, Alert, Space, Divider } from "antd";
import { UserOutlined, LockOutlined, DotChartOutlined } from "@ant-design/icons";
import { login } from "../services/api";
import { setCredentials } from "../store";

const { Title, Text } = Typography;

export default function LoginPage() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const [form, setForm]     = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState(null);

  const handleLogin = async () => {
    if (!form.email || !form.password) {
      setError("Email and password are required");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const { data } = await login(form);
      dispatch(setCredentials({ user: data.user, accessToken: data.accessToken }));
      navigate("/upload", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:       "100vh",
      display:         "flex",
      alignItems:      "center",
      justifyContent:  "center",
      background:      "linear-gradient(135deg, #0f1f30 0%, #1A3C5E 60%, #2E86AB 100%)",
    }}>
      <Card style={{ width: 420, borderRadius: 12, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <DotChartOutlined style={{ fontSize: 40, color: "#2E86AB" }} />
          <Title level={3} style={{ margin: "8px 0 4px", color: "#1A3C5E" }}>
            SEC Parser
          </Title>
          <Text type="secondary">AI Financial Intelligence Platform</Text>
        </div>

        <Divider />

        <Space direction="vertical" size={14} style={{ width: "100%" }}>
          {error && <Alert type="error" message={error} showIcon />}

          <div>
            <Text strong style={{ fontSize: 13 }}>Email</Text>
            <Input
              prefix={<UserOutlined style={{ color: "#bbb" }} />}
              placeholder="you@company.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              onPressEnter={handleLogin}
              size="large"
              style={{ marginTop: 4 }}
            />
          </div>

          <div>
            <Text strong style={{ fontSize: 13 }}>Password</Text>
            <Input.Password
              prefix={<LockOutlined style={{ color: "#bbb" }} />}
              placeholder="••••••••"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              onPressEnter={handleLogin}
              size="large"
              style={{ marginTop: 4 }}
            />
          </div>

          <Button
            type="primary"
            size="large"
            block
            loading={loading}
            onClick={handleLogin}
            style={{ background: "#1A3C5E", marginTop: 8, height: 44 }}
          >
            Sign In
          </Button>

          <Text type="secondary" style={{ fontSize: 12, textAlign: "center", display: "block" }}>
            Access is invite-only. Contact your administrator to get an account.
          </Text>
        </Space>
      </Card>
    </div>
  );
}